import { Component } from '@angular/core';
import {GritInterferenceTestDeviceService} from "../../../services/grit/grit.interference-test-device.service";
import {TabsService} from "../../../services/tabsService";
import {MapService} from "../../../services/map.service";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {CoordenateService} from "../../../services/coordenate.service";
import {PointsService} from "../../../services/points.service";
import {ModalConfirmationService} from "../../../services/modal-confirmation.service";
import {UiBlockService} from "../../../services/ui-block.service";
import {ModalControlService} from "../../../services/modal-control.service";
import {GritInterferenceTestService} from "../../../services/grit/grit.interference-test.service";
import {BsModalService} from "ngx-bootstrap/modal";
import {toLonLat} from "ol/proj";
import {GritDeviceService} from "../../../services/grit/grit.device.service";
import {DeviceModel, InterferenceTestDeviceModel} from "../../../models/grit/grit.device-model";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";

@Component({
  selector: 'app-interference-test-device',
  templateUrl: './interference-test-device.component.html',
  styleUrls: ['../../../app.component.scss', './interference-test-device.component.scss'],
  standalone: false
})
export class InterferenceTestDeviceComponent {
  tabActive: boolean[] = [true, false];

  constructor(
    public itDeviceService: GritInterferenceTestDeviceService,
    public deviceService: GritDeviceService,
    public gritUserService: GritUserService,
    public tabsService: TabsService,
    private mapService:MapService,
    private gritAPIService:GritApiService,
    private rcsControl: CoordenateService,
    private pointsService: PointsService,
    private modalConfirmation: ModalConfirmationService,
    private uiBlock: UiBlockService,
    private modalService: ModalControlService,
    private interferenceTestService : GritInterferenceTestService,
    private popupService : BsModalService,
  ) {

    this.mapService.getMap('map').on("dblclick", this.dblClickHandler.bind(this));
  }

  activateTab(n: number) {
    this.tabActive.forEach((_t, i) => {
      this.tabActive[i] = (i == n);
    })
  }

  changeDevice(id: string){
    let device = this.deviceService.devices.find(device => device.id == Number(id));
    this.itDeviceService.selectedDevice.device = device;
  }

  dblClickHandler(evt) {
    var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
    this.itDeviceService.selectedDevice.latitude.value = coords[1];
    this.itDeviceService.selectedDevice.longitude.value = coords[0];

    this.updateMaskArea();
  }

  updateMaskArea(){
    let device = this.itDeviceService.selectedDevice;
    // if (device.maskRadius > this.interferenceTestService.projectInterferenceTest.deviceMaskRadius){}
    let projection = this.mapService.getMaps().getView().getProjection();
    let radius = device.maskRadius * 1000
    device.defineHiddenArea(radius, projection)
  }

  submit(created: boolean){
    let deviceUpdate = this.itDeviceService.selectedDevice;
    let config = {
      title: "Save RFI-Transmitter",
      titleSuccess: "RFI-Transmitter Saved",
      message: created ?
        "Create new RFI-Transmitter?" :
        "You are editing a published RFI-Transmitter, do you wish to continue and save the changes?",
      messageSuccess: created ?
        "The RFI-Transmitter was created sucessfully!" :
        "The RFI-Transmitter was edited sucessfully!",
      endpoint: created ?
        this.gritAPIService.itDeviceCreate.bind(this.gritAPIService, [deviceUpdate]) :
        this.gritAPIService.itDeviceUpdate.bind(this.gritAPIService, [deviceUpdate])
    }

    this.modalConfirmation.showMesssageConfirmationModal(
      config.title,
      config.message,
      "OK", "Cancel",
      () => {
        this.uiBlock.startBlock("Saving RFI-Transmitter...")

        return config.endpoint().then(
          (devices: InterferenceTestDeviceModel[]) => {
            //Map
            this.pointsService.addDevicesToMap(devices);

            this.modalService.showMesssageModal(config.titleSuccess, config.messageSuccess);
            this.tabsService.closeTab()
          },
          (response) => {
            let message : string  = '';
            response['error']['errors'].map(error => message += `${error['message']};\n`);
            this.modalService.showMesssageModal('Error Saving RFI-Transmitter', message);
          }
        ).finally(() => this.uiBlock.stopBlock());
      }
    );
  }

  // protected readonly InterferenceTestModel = InterferenceTestModel;
  protected readonly DeviceModel = DeviceModel;
  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
